/**
 * additional-steps-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * A client sends an {@link AdditionalStepsRequest} to request additional
 * {@link IntakeStep intake step}s from the server. Certain selection
 * algorithms do not provide every eligible intake step when they {@link
 * NextStepsResponse provide intake steps}, so the client may wish to explicitly
 * request more at the user's behest. If there are more eligible intake steps
 * available, then the server replies with a {@link NextStepsResponse} that
 * includes never-before-seen steps and the message identifier of the request.
 * If no more intake steps are eligible, then the server replies with a {@link
 * AcknowledgmentRespons} carrying the {@linkplain ResponseCode response
 * code} REQUEST_FAILED.
 */
export class AdditionalStepsRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_ADDITIONAL_STEPS;
	public static tag : MessageTag = MessageTag.REQ_ADDITIONAL_STEPS;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/algorithms/additional-steps-request.ts